<template>
	<div>
		<form-sidebar>
			<v-form>
				<v-layout wrap>
					<v-flex xs12>
						<BaseInput
							:height="38"
							label="Código"
							v-model="$v.model.code.$model"
						/>
					</v-flex>
					<v-flex xs12>
						<BaseInput
							:height="38"
							label="Nombre"
							v-model="$v.model.name.$model"
						/>
					</v-flex>
						<v-flex xs12>
							<BaseSelect
								label="Módulos"
								item-text="name"
								item-value="id"
								:height="38"
								:disabled="mode.isEditing"
								:items="modules"
								v-model="model.moduleId"
							/>
						</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						@cancel-button-clicked="$emit('close-modal')"
						@accept-button-clicked="submitForm"
						:is-loading="disableButton"
					>
					</modal-sidebar-button>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>

import { required } from 'vuelidate/lib/validators';

function data() {
	return {
		isLoading: false,
		model: {
			code: '',
			moduleId: null,
			name: '',
		},
		modules: [],
	};
}

function createDefinitionModel({ model, customerId, isEditing, subsidiaryId }) {
	const newDefinition = {
		name: model.name,
		code: model.code,
	};
	if (!isEditing) {
		newDefinition.customerId = customerId;
		newDefinition.subsidiaryId = subsidiaryId;
		newDefinition.moduleId = model.moduleId;
	}
	return newDefinition;
}

async function created() {
	const requests = [this.$http.get('type-register', { params: { subsidiaryId: this.subsidiaryId } })];
	if (this.mode.isEditing) {
		requests.push(this.$http.get(`accounting-definitions-details/${this.id}`));
	}
	const [modules, accountDefinition] = await Promise.all(requests);
	this.modules = modules.data;
	if (this.modules.length > 0) {
		this.model.moduleId = this.modules[0].id;
	}
	if (accountDefinition) {
		this.model = {
			code: accountDefinition.data.code,
			name: accountDefinition.data.name,
			moduleId: accountDefinition.data.moduleId,
		};
	}
}

function disableButton() {
	return this.$v.$invalid || this.loading;
}

function mode() {
	const isEditing = Boolean(this.id);
	return {
		isEditing,
		method: isEditing ? 'patch' : 'post',
		url: isEditing ? `accounting-definitions/${this.id}/${this.customerId}` : 'accounting-definitions',
	};
}

async function submitForm() {
	this.isLoading = true;
	const definition = createDefinitionModel({
		customerId: this.customerId,
		isEditing: this.mode.isEditing,
		model: this.model,
		subsidiaryId: this.subsidiaryId,
	});
	try {
		await this.$http[this.mode.method](this.mode.url, definition);
		this.$emit('close-modal', true);
		this.showNotification('Definición Contable registrada correctamente');
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		} else if (error.status === 400) {
			if (error.data.message === 'CODE_ACCOUNTING_DEFINITION_DUPLICATE') {
				this.showNotification('Código de la definición ya existente.', 'error');
			}
		}
	} finally {
		this.isLoading = false;
	}
}

function validations() {
	const validation = {
		model: {
			name: {
				required,
			},
			code: {
				required,
			},
			moduleId: {
				required,
			},
		},
	};
	return validation;
}

export default {
	name: 'account-definitions-form',
	created,
	components: {
		BaseInput: () => import('@/components/shared/inputs/base-input'),
		BaseSelect: () => import('@/components/shared/inputs/base-select'),
	},
	computed: {
		disableButton,
		mode,
	},
	data,
	methods: {
		submitForm,
	},
	props: {
		customerId: {
			type: Number,
			required: true,
		},
		id: {
			type: Number,
			default: null,
		},
		subsidiaryId: {
			type: Number,
			required: true,
		},
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/components/account-definitions/account-definitions-form.vue